"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UrlRegexFactory = _interopRequireDefault(require("./factories/UrlRegexFactory"));

var URL_REGEX = (0, _UrlRegexFactory.default)();
var _default = URL_REGEX;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.189/js/regex/UrlRegex.js
// module id = 214
// module chunks = 0